var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActRelax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 510 510",
    style: {
      enableBackground: "new 0 0 510 510"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#F7A797;}\n\t.st3{fill:#BCF1CE;}\n\t.st4{fill:#C3E5F0;}\n\t.st5{fill:#9DD4E7;}\n\t.st6{fill:#FFD482;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M436.3,79.7c-36.6-37.8-84.8-63.9-136.7-73.1c-53-9.4-108.1-1.9-156.5,21.8C96.5,51.3,57.2,89.1,32.5,134.8 C7.4,181.2-2.6,235.2,4.2,287.6c5.9,44.9,23.7,87.3,51.5,123c27.4,35.1,63.9,62.3,105.2,79c43,17.4,90.7,22,136.4,14.4 c44.1-7.4,85.7-27,120-55.8c34.1-28.6,60.1-66.3,75.2-108.1c17.4-48.2,19.3-101.9,5.9-151.4c-3.7-13.7-8.7-27.1-14.7-40 c-1.7-3.7-7-4.5-10.3-2.7c-3.8,2.2-4.4,6.6-2.7,10.3c39.5,86.3,22.7,190.7-41.8,260.1c-58.9,63.4-149.6,90.3-233.5,68.7 c-81.5-21-147.4-85.7-169.8-166.9c-12.7-46.3-11-96,4.7-141.4C46.5,130,77.8,88.7,118.4,60.4c41.3-28.8,90.9-43.8,141.2-42.8 c50.3,1,99.5,18.3,139.5,48.8c9.5,7.3,18.4,15.3,26.7,23.9C432.4,97.2,443,86.6,436.3,79.7L436.3,79.7z"
  })))), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 360,
    height: 360,
    xlinkHref: "CDFA8C02.jpg",
    transform: "matrix(1 0 0 1 -7942 -7942)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 360,
    height: 360,
    xlinkHref: "CDFA8C06.jpg",
    transform: "matrix(1 0 0 1 -522.5 108.5)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M456.2,355.9C471.4,325.5,480,291.3,480,255c0-124.3-100.7-225-225-225S30,130.7,30,255 c0,34.9,7.9,67.9,22.1,97.3C92.5,325.2,166.7,307,251.6,307C340.1,307,417.1,326.8,456.2,355.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M178.9,466.8c-4.6-7.5-9.7-16.1-15.4-26.1c0,0-18-25.2-29.1-26.4c-23.3,0-23.3-35.7,0-35.7 c0,0,35.4-9.6,78.2,71.3v-64.6H173c-2.9,0-5.9-0.4-8.7-1.3c-10.9-3.5-34.5-14.6-15.9-40.8c2-2.9,4.7-5.2,7.8-6.8 c36.2-19,98.7-14.7,98.7-14.7s62.5-4.3,98.7,14.7c3.1,1.6,5.8,3.9,7.8,6.8c18.6,26.2-5.1,37.3-15.9,40.8c-2.8,0.9-5.7,1.3-8.7,1.3 h-39.6v64.6c42.8-80.9,78.2-71.3,78.2-71.3c23.3,0,23.3,35.7,0,35.7c-11.1,1.2-29.1,26.4-29.1,26.4c-5.7,10-10.8,18.6-15.4,26.1 c54.5-19.6,99.3-59.7,125.1-110.9c-39.1-29.1-116-48.9-204.6-48.9c-84.9,0-159.1,18.2-199.5,45.3 C77.5,405.3,123.1,446.8,178.9,466.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M375.6,414.3c23.3,0,23.3-35.7,0-35.7c0,0-35.4-9.6-78.2,71.3v-64.6H337c2.9,0,5.9-0.4,8.7-1.3 c10.9-3.5,34.5-14.6,15.9-40.8c-2-2.9-4.7-5.2-7.8-6.8c-36.2-19-98.7-14.7-98.7-14.7s-62.5-4.3-98.7,14.7 c-3.1,1.6-5.8,3.9-7.8,6.8c-18.6,26.2,5.1,37.3,15.9,40.8c2.8,0.9,5.7,1.3,8.7,1.3h39.6v64.6c-42.8-80.9-78.2-71.3-78.2-71.3 c-23.3,0-23.3,35.7,0,35.7c11.1,1.2,29.1,26.4,29.1,26.4c5.7,10,10.8,18.6,15.4,26.1c23.8,8.5,49.4,13.2,76.1,13.2 c26.7,0,52.3-4.7,76.1-13.2c4.6-7.5,9.7-16.1,15.4-26.1C346.5,440.7,364.5,415.5,375.6,414.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M375.6,274.7c-11.1-1.2-29.1-26.4-29.1-26.4c-38.1-66.7-50.6-73.4-50.6-73.4c-13.2-14.5-40.9-12.5-40.9-12.5 s-27.8-2-40.9,12.5c0,0-12.5,6.7-50.6,73.4c0,0-18,25.2-29.1,26.4c-23.3,0-23.3,35.7,0,35.7c0,0,35.4,9.6,78.2-71.3v64.6H173 c-2.9,0-5.9,0.4-8.7,1.3c-10.9,3.5-34.5,14.6-15.9,40.8c2,2.9,4.7,5.2,7.8,6.8c36.2,19,98.7,14.7,98.7,14.7s62.5,4.3,98.7-14.7 c3.1-1.6,5.8-3.9,7.8-6.8c18.6-26.2-5.1-37.3-15.9-40.8c-2.8-0.9-5.7-1.3-8.7-1.3h-39.6v-64.6c42.8,80.9,78.2,71.3,78.2,71.3 C398.8,310.5,398.8,274.7,375.6,274.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 255,
    cy: 115.8,
    r: 46.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActRelax);
export default __webpack_public_path__ + "static/media/ActRelax.6bbca0208826a82265aa6af158debe72.svg";
export { ForwardRef as ReactComponent };